/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './centerMap.less';
import StationListApi from 'src/pages/stationList/api/stationListApi';
import Bus, { Events } from 'src/util/bus';
import { applyOfficialMapStyle, applyTdtTheme, createLngLat, createMarkerIcon, ensureTianDiTuLoaded, getT } from 'src/util/tianditu';

let bem = createBEM('center-map');

export interface CenterMapPropsI {
    value: string | number;
}

@Component
export default class CenterMap extends Vue.Component<{ type: number }> {
    @Prop({
        type: Number,
    })
    type!: number;
    map: any;
    markers: any[] = [];

    getDotIcon() {
        let svg = encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <circle cx="14" cy="14" r="6" fill="#66ff00" fill-opacity="0.95"/>
                <circle cx="14" cy="14" r="6" fill="#66ff00" fill-opacity="0.45">
                    <animate attributeName="r" values="6;12;6" dur="1.8s" repeatCount="indefinite"/>
                    <animate attributeName="fill-opacity" values="0.45;0;0.45" dur="1.8s" repeatCount="indefinite"/>
                </circle>
                <circle cx="14" cy="14" r="6" fill="#66ff00" fill-opacity="0.28">
                    <animate attributeName="r" values="6;15;6" dur="1.8s" begin="0.9s" repeatCount="indefinite"/>
                    <animate attributeName="fill-opacity" values="0.28;0;0.28" dur="1.8s" begin="0.9s" repeatCount="indefinite"/>
                </circle>
            </svg>
        `);
        return createMarkerIcon(`data:image/svg+xml;charset=UTF-8,${svg}`, 28, 28);
    }

    async initMap() {
        let TMap = await ensureTianDiTuLoaded();
        var map = new TMap.Map('container');
        this.map = map;
        applyTdtTheme('container');
        map.enableScrollWheelZoom(true);
        map.centerAndZoom(createLngLat(116.404, 39.915), 12);
        applyOfficialMapStyle(map, 'indigo');
    }

    @Watch('type')
    typeChange() {
        this.searchStations();
    }

    async mounted() {
        await this.initMap();
        this.searchStations();
    }

    async searchStations() {
        let TMap = getT();
        let { code, data } = await StationListApi.searchDeviceList({ type: this.type });
        if (code !== 0) {
            return;
        }
        let points: any[] = [];
        this.markers.forEach(i => this.map.removeOverLay(i));
        this.markers = [];
        let statusMap = {};
        let dotIcon = this.getDotIcon();
        data.data_info.forEach(i => {
            let point = i.location_point.split(',');
            let lngLat = createLngLat(point[0], point[1]);
            points.push(lngLat);
            statusMap[i.device_status] = statusMap[i.device_status] || 0;
            statusMap[i.device_status]++;
            let marker = new TMap.Marker(lngLat, {
                icon: dotIcon,
            });
            this.map.addOverLay(marker);
            this.markers.push(marker);
        });
        Bus.$emit(Events.DeviceStatusReady, statusMap);
        if (points.length) {
            this.map.setViewport(points);
        }
    }
    beforeDestroy() {
        this.markers.forEach(i => this.map.removeOverLay(i));
        this.markers = [];
    }
    render(h) {
        return (
            <div class={bem()}>
                <div id="container" style="height:calc(100% + 25px);width:calc(100% + 22px);margin-left: -10px" />
            </div>
        );
    }
}
